import React from "react";
import { Icon as IconBUI } from "@bookingcom/bui-react";
import styles from "./Icon.module.css";
const Icon = (props) => {
    const { className, rtlAutoFlip, ...rest } = props;
    const classNames = [className, rtlAutoFlip && styles.icon].filter(Boolean).join(" ");
    return React.createElement(IconBUI, { ...rest, className: classNames });
};
export default Icon;
